import { z } from 'zod';
import { WEIGHT_UNIT_VALUES } from '@/shared/types/api/packages';

/**
 * Decimal string validator: empty → undefined; otherwise must parse to a
 * non-negative finite number. Accepts comma as decimal separator.
 */
const decimalString = z
  .string()
  .trim()
  .refine(
    (v) => {
      if (v === '') return true;
      const n = Number(v.replace(',', '.'));
      return Number.isFinite(n) && n >= 0;
    },
    { message: 'packages.form.errors.invalidNumber' },
  );

export const packageFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, 'packages.form.errors.nameRequired')
    .max(255, 'packages.form.errors.tooLong'),
  weight: decimalString.optional().or(z.literal('')),
  weight_unit: z.enum(WEIGHT_UNIT_VALUES),
});

export type PackageFormValues = z.infer<typeof packageFormSchema>;
